<template>
	<div class="Echarts">
		<div id="main" style="width: 1200px;height:400px;"></div>
	</div>
</template>

<script>
	export default {
		name: 'Echarts',
		props: ['yudata'],
		methods: {
			myEcharts() {
				console.log(this.yudata)
				let xAxisData = []
				let seriesData = []
				this.yudata.forEach(function(index, vle) {
					xAxisData.push(index.createdTime)
					seriesData.push(index.val)
				})
				// 基于准备好的dom，初始化echarts实例
				var myChart = this.$echarts.init(document.getElementById('main'),'light');
				// 指定图表的配置项和数据
				var option = {
					tooltip: {
						trigger: "axis",
						axisPointer: {
							lineStyle: {
								type: "dashed"
							},
						},
					},
					textStyle: {
						color: "#ffffff"
					},
					legend: {
						right: "0",
						top: "5%",
						textStyle: {
							color: "#ffffff"
						},
						data: ['预警值']
					},
					xAxis: {
						type: "category",
						data: xAxisData,
						splitLine: {
							show: false
						},
						axisTick: false,
						axisLine: {
							lineStyle: {
								color: "#32b16c"
							},
						},
						axisLabel: {
							interval: 3,
							rotate: 0,
						},
						inverse:false,
						// min:function(value){
						// 	return value.min+3
						// }
					},
					yAxis: {
						type: "value",
						scale: "true",
						axisTick: false,
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ["#2a2f57"],
							},
						},
						axisLine: {
							lineStyle: {
								color: "#32b16c"
							},
						},
						splitNumber: "5",
						
					},
					dataZoom: [{
						type: "inside",
						xAxisIndex: [0],
						startValue: 0,
						endValue: 8,
						minValueSpan: 12,
						maxValueSpan: 12,
						filterMode: "empty",
					}, ],
					series: [{
						name: '值',
						type: "line",
						symbol: "circle",
						data: seriesData,
						smooth: true
					}]
				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			}
		},
		mounted() {
			this.myEcharts();
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/page/maintain/warn/myChartYu.vue